import { useState } from "react";
import { PackageCheck, Truck, Warehouse as WarehouseIcon, Boxes, ClipboardList, MapPin, Calculator } from "lucide-react";
import { ShipmentTrackingTab } from "./ShipmentTrackingTab";
import { ReceiptsTab } from "./ReceiptsTab";
import { CalculationsTab } from "../Calculations/CalculationsTab";
import { SuppliersTab } from "./SuppliersTab";
import { WarehousesTab } from "./WarehousesTab";
import { StockTab } from "./StockTab";
import { WarehouseOrdersTab } from "./WarehouseOrdersTab";

type TabKey = "prijem" | "kalkulacije" | "dobavljaci" | "lager" | "magacini" | "nalozi" | "posiljke";

const TABS: { key: TabKey; label: string; icon: typeof PackageCheck }[] = [
  { key: "prijem", label: "Prijem robe", icon: PackageCheck },
  { key: "kalkulacije", label: "Kalkulacije", icon: Calculator },
  { key: "dobavljaci", label: "Dobavljači", icon: Truck },
  { key: "lager", label: "Lager", icon: Boxes },
  { key: "magacini", label: "Magacini", icon: WarehouseIcon },
  { key: "nalozi", label: "Nalozi magacinu", icon: ClipboardList },
  { key: "posiljke", label: "Praćenje pošiljki", icon: MapPin },
];

export function GoodsReceiptsPage() {
  const [tab, setTab] = useState<TabKey>("prijem");

  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-xl font-semibold text-slate-900">Magacinsko poslovanje</h1>
        <p className="text-sm text-slate-500">
          Prijem robe, kalkulacija nabavne cene, dobavljači, lager i nalozi magacinu
        </p>
      </div>

      <div className="flex gap-1 border-b border-border">
        {TABS.map((t) => (
          <button
            key={t.key}
            onClick={() => setTab(t.key)}
            className={`flex items-center gap-1.5 border-b-2 px-4 py-2 text-sm font-medium ${
              tab === t.key
                ? "border-brand text-brand"
                : "border-transparent text-slate-500 hover:text-slate-700"
            }`}
          >
            <t.icon className="h-4 w-4" aria-hidden />
            {t.label}
          </button>
        ))}
      </div>

      {tab === "prijem" && <ReceiptsTab />}
      {tab === "kalkulacije" && <CalculationsTab />}
      {tab === "dobavljaci" && <SuppliersTab />}
      {tab === "lager" && <StockTab />}
      {tab === "magacini" && <WarehousesTab />}
      {tab === "nalozi" && <WarehouseOrdersTab />}
      {tab === "posiljke" && <ShipmentTrackingTab />}
    </div>
  );
}
